import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalculator } from "@fortawesome/free-solid-svg-icons";
import USQSFormGroup from "./USQSFormGroup";
import SearchField from "../SearchField/SearchField";
import useUSQS from "../../hooks/useUSQS";
import { handleFigureChange, handleFigureBlur, handleInputSelect, addEdits } from "./utils/inputhandlers";
import useUSQSUndo from "../../hooks/useUSQSUndo";
import useGlobalParams from "../../hooks/useGlobalParams";

const QSUSAFigures = ({
  ignoreEnter,
  setShowcalculator,
  showcalculator,
  resetOutbound,
  resetOceanfreight,
  resetCustoms,
  resetInbound,
  clearfield,
}) => {
  // Load context values
  const { USQS, setUSQS, setUSQSData } = useUSQS();
  const { USQSEdits, editIDUSQS, setEditIDUSQS, editingFieldUSQS, setEditingFieldUSQS, undoListUSQS, inputRefsUSQS } =
    useUSQSUndo();
  const { globalparams } = useGlobalParams();

  // Local handleFigureChange and handleFigureBlur functions to allow shorthand in input component.
  const localHandleFigureChange = (e, type, dec = 2) => {
    handleFigureChange(e, type, setUSQS, setUSQSData, setEditingFieldUSQS, dec);
  };
  const localHandleFigureBlur = (e, type, dec = 2) => {
    handleFigureBlur(
      e,
      type,
      setUSQS,
      USQSEdits,
      editIDUSQS,
      setEditIDUSQS,
      editingFieldUSQS,
      setEditingFieldUSQS,
      undoListUSQS,
      dec
    );
  };
  const localHandleInputSelect = (item, origin, destination) => {
    handleInputSelect(
      item,
      USQSEdits,
      editIDUSQS,
      setEditIDUSQS,
      setUSQS,
      setUSQSData,
      addEdits,
      undoListUSQS,
      origin,
      destination,
      globalparams
    );
  };
  return (
    <>
      <fieldset>
        <legend>Figures:</legend>
        <div className='form-group'>
          <label>Quantity (mt):</label>
          <div className='USqtyandtolerance'>
            <input
              required
              autoComplete='off'
              type='text'
              name='quantity'
              value={USQS?.quantity || ""}
              onKeyDown={ignoreEnter}
              onFocus={(e) => e.target.select()}
              onChange={(e) => localHandleFigureChange(e, "decimal")}
              onBlur={(e) => localHandleFigureBlur(e, "decimal")}
              ref={(el) => (inputRefsUSQS.current["quantity"] = el)}
            />
            <p>+/-</p>
            <input
              required
              style={{ minWidth: "35px", maxWidth: "45px" }}
              value={USQS?.tolerance || ""}
              onFocus={(e) => e.target.select()}
              // onChange={(e) => handlePercentageChange(e, setUSposition, setUSpositionData, 2)}
              onChange={(e) => localHandleFigureChange(e, "percent", 2)}
              // onBlur={(e) => handlePercentageBlur(e, setUSposition, 2)}
              onBlur={(e) => localHandleFigureBlur(e, "percent", 2)}
              onKeyDown={ignoreEnter}
              name='tolerance'
              placeholder='% ...'
              ref={(el) => (inputRefsUSQS.current["tolerance"] = el)}
            />
          </div>
        </div>
        <USQSFormGroup labelname={"# Pallets"} inputname={"numpallets"} inputtype={"decimal"} />
      </fieldset>
      <fieldset>
        <legend>Costs (per mt):</legend>
        <USQSFormGroup
          readOnly={USQS.qstype === 2 ? true : false}
          labelname={USQS.qstype === 2 ? "Landed Cost" : " Material Cost"}
          inputname={"materialcost"}
          inputtype={"currency"}
        />
        {USQS.qstype !== 2 && (
          <>
            <USQSFormGroup labelname={"P Commission"} inputname={"pcomission"} inputtype={"currency"} />
            <USQSFormGroup labelname={"P Finance Cost"} inputname={"pfinancecost"} inputtype={"currency"} />{" "}
          </>
        )}
        {USQS.qstype == 2 && <USQSFormGroup readOnly={true} labelname={"Storage Cost"} inputname={"storagecost"} />}
        <div className='form-group'>
          <label>
            Outbound Cost:{" "}
            <FontAwesomeIcon
              icon={faCalculator}
              onClick={(e) => {
                setShowcalculator("outboundcost");
              }}
            />
          </label>
          <input
            readOnly
            required
            type='text'
            name='outboundcost'
            value={USQS?.outboundcost || ""}
            onKeyDown={ignoreEnter}
            onFocus={(e) => e.target.select()}
          />
        </div>
        {showcalculator === "outboundcost" && (
          <div className='USbottompopupcalculator' style={{ position: "absolute" }}>
            <USQSFormGroup labelname={"Payload (mt/FCL)"} inputname={"outpayload"} inputtype={"decimal"} />
            <USQSFormGroup labelname={"Drayage per FCL"} inputname={"outdrayage"} inputtype={"currency"} />
            <USQSFormGroup labelname={"Loading Fee per FCL"} inputname={"loading"} inputtype={"currency"} />
            <USQSFormGroup labelname={"Collect Charges"} inputname={"outcollectcharges"} inputtype={"currency"} />
            <USQSFormGroup labelname={"Outbound others"} inputname={"outboundothers"} inputtype={"currency"} />
            <USQSFormGroup readOnly={true} labelname={"Total Outbound"} inputname={"totaloutbound"} />
            <button
              onClick={(e) => {
                e.preventDefault();
                // setEditing(true);
                resetOutbound();
              }}
            >
              Reset
            </button>
            <button
              onClick={(e) => {
                e.preventDefault();
                setShowcalculator("");
              }}
            >
              OK
            </button>
          </div>
        )}
        {USQS.qstype !== 2 && (
          <div className='form-group'>
            <label>
              Ocean Freight:
              <FontAwesomeIcon
                icon={faCalculator}
                onClick={(e) => {
                  setShowcalculator("oceanfreight");
                }}
              />
            </label>
            <input
              readOnly
              required
              type='text'
              name='freightpmt'
              value={USQS?.freightpmt || ""}
              onKeyDown={ignoreEnter}
              onFocus={(e) => e.target.select()}
            />
          </div>
        )}
        {showcalculator === "oceanfreight" && (
          <div className='USbottompopupcalculator' style={{ position: "absolute" }}>
            <USQSFormGroup labelname={"Payload (mt)"} inputname={"oceanpayload"} inputtype={"decimal"} />
            <USQSFormGroup labelname={"Total Freight"} inputname={"oceanfreight"} inputtype={"currency"} />
            <button
              onClick={(e) => {
                e.preventDefault();
                resetOceanfreight();
              }}
            >
              Reset
            </button>
            <button
              onClick={(e) => {
                e.preventDefault();
                setShowcalculator("");
              }}
            >
              OK
            </button>
          </div>
        )}
        {USQS.qstype !== 2 && (
          <div className='form-group'>
            <label>
              Import Customs Fee:{" "}
              <FontAwesomeIcon
                icon={faCalculator}
                onClick={(e) => {
                  setShowcalculator("importcustomsfee");
                }}
              />
            </label>
            <input
              readOnly
              required
              type='text'
              name='importcustomsfee'
              value={USQS?.importcustomsfee || ""}
              onKeyDown={ignoreEnter}
              onFocus={(e) => e.target.select()}
            />
          </div>
        )}
        {showcalculator === "importcustomsfee" && (
          <div className='USbottompopupcalculator' style={{ position: "absolute" }}>
            <USQSFormGroup labelname={"Quantity"} inputname={"quantity"} inputtype={"decimal"} />
            <USQSFormGroup labelname={"Material Cost/mt"} inputname={"materialcost"} inputtype={"currency"} />
            <USQSFormGroup readOnly={true} labelname={"Material Value"} inputname={"materialvalue"} />
            <USQSFormGroup labelname={"General Duty(%)"} inputname={"generaldutyimp"} inputtype={"percent"} />
            <USQSFormGroup labelname={"Additional Duty(%)"} inputname={"additionaldutyimp"} inputtype={"percent"} />
            <USQSFormGroup readOnly={true} labelname={"Total Duty(%)"} inputname={"totalduty"} />
            <USQSFormGroup readOnly={true} labelname={"Duty Fee"} inputname={"dutyfee"} />
            <USQSFormGroup labelname={"Harbor Fee(%)"} inputname={"harborfeepct"} inputtype={"percent"} />
            <USQSFormGroup readOnly={true} labelname={"Harbor Fee"} inputname={"harborfee"} />
            <USQSFormGroup labelname={"Merch. Proc. Fee(%)"} inputname={"merchprocfeepct"} inputtype={"percent"} />
            <USQSFormGroup readOnly={true} labelname={"Merch. Proc. Fee"} inputname={"merchprocfee"} />
            <USQSFormGroup labelname={"Flat fee"} inputname={"flatfee"} inputtype={"currency"} />
            <USQSFormGroup labelname={"TSCA"} inputname={"tsca"} inputtype={"currency"} />
            <USQSFormGroup labelname={"ISF"} inputname={"isf"} inputtype={"currency"} />
            <USQSFormGroup readOnly={true} labelname={"Total Entry Fee"} inputname={"totalcentryfee"} />
            <button
              onClick={(e) => {
                e.preventDefault();
                // setEditing(true);
                resetCustoms();
              }}
            >
              Reset
            </button>
            <button
              onClick={(e) => {
                e.preventDefault();
                setShowcalculator("");
              }}
            >
              OK
            </button>
          </div>
        )}
        {USQS.qstype !== 2 && (
          <div className='form-group'>
            <label>
              Inbound Cost:{" "}
              <FontAwesomeIcon
                icon={faCalculator}
                onClick={(e) => {
                  setShowcalculator("inboundcost");
                }}
              />
            </label>
            <input
              readOnly
              required
              type='text'
              name='inboundcost'
              value={USQS?.inboundcost}
              onKeyDown={ignoreEnter}
              onFocus={(e) => e.target.select()}
            />
          </div>
        )}
        {showcalculator === "inboundcost" && (
          <div className='USbottompopupcalculator' style={{ position: "absolute" }}>
            <USQSFormGroup labelname={"Payload (mt/FCL)"} inputname={"inpayload"} inputtype={"decimal"} />
            <USQSFormGroup labelname={"Drayage per FCL"} inputname={"indrayage"} inputtype={"currency"} />
            <USQSFormGroup labelname={"Loading Fee per FCL"} inputname={"unloading"} inputtype={"currency"} />
            <USQSFormGroup labelname={"Collect Charges"} inputname={"incollectcharges"} inputtype={"currency"} />
            <USQSFormGroup labelname={"Outbound others"} inputname={"inboundothers"} inputtype={"currency"} />
            <USQSFormGroup readOnly={true} labelname={"Total Inbound"} inputname={"totalinbound"} />
            <button
              onClick={(e) => {
                e.preventDefault();
                // setEditing(true);
                resetInbound();
              }}
            >
              Reset
            </button>
            <button
              onClick={(e) => {
                e.preventDefault();
                setShowcalculator("");
              }}
            >
              OK
            </button>
          </div>
        )}
        <USQSFormGroup labelname={"S Comission"} inputname={"scomission"} inputtype={"currency"} />
        <USQSFormGroup labelname={"S Finance Cost"} inputname={"sfinancecost"} inputtype={"currency"} />
        <USQSFormGroup labelname={"Inspection Cost"} inputname={"inspectioncost"} inputtype={"currency"} />
        <USQSFormGroup labelname={"Legal"} inputname={"legal"} inputtype={"currency"} />
        <USQSFormGroup labelname={"Pallets"} inputname={"pallets"} inputtype={"currency"} />
        <USQSFormGroup labelname={"Other"} inputname={"other"} inputtype={"currency"} />
        <USQSFormGroup
          readOnly={true}
          labelname={"Total Cost"}
          inputname={"totalcost"}
          rowStyle={{ marginTop: "1rem" }}
        />
        <div style={{ marginTop: "1.5rem" }} className='form-group'>
          <label style={{ position: "relative" }}>
            Insurance Cost:{" "}
            <FontAwesomeIcon
              icon={faCalculator}
              onClick={(e) => {
                setShowcalculator("insurance");
              }}
            />
          </label>
          <input type='text' name='insurancecost' readOnly value={USQS.insurancecost || ""} onKeyDown={ignoreEnter} />
        </div>
        {showcalculator === "insurance" && (
          <div className='USbottompopupcalculator' style={{ position: "absolute" }}>
            <div className='form-group'>
              <label htmlFor=''>D Incoterms:</label>
              <SearchField
                required={true}
                searchURL='/api/qs/getsincoterms'
                value={USQS?.sincoterm || ""}
                valueName='sincoterm'
                valueID='sincotermID'
                customplaceholder='S Incoterm'
                onItemSelect={(item) => localHandleInputSelect(item, "sincoterm", "sincoterm")}
                clearfield={clearfield}
              />
            </div>
            <USQSFormGroup labelname={"Insurance Rate %"} inputname={"insurancerate"} inputtype={"percent"} />
            <USQSFormGroup labelname={"Insurance Factor"} inputname={"insurancefactor"} inputtype={"decimal"} />
            <button
              onClick={(e) => {
                e.preventDefault();
                setShowcalculator("");
              }}
            >
              OK
            </button>
          </div>
        )}
        <USQSFormGroup readOnly={true} labelname={"Interest Cost"} inputname={"interestcost"} />
        <USQSFormGroup
          readOnly={true}
          labelname={USQS.qstype !== 2 ? "Total Landed Cost" : "Total Cost + Int + Ins"}
          inputname={"totallandedcost"}
          rowStyle={{ marginTop: "1rem" }}
        />
      </fieldset>
    </>
  );
};

export default QSUSAFigures;
